import styled from "styled-components";

export const Container = styled.div`
  /* background-color: red; */
  width: 100%;
  max-height: 200px;
`;
